import { useState } from "react";

import { AiFillEye, AiFillMinusCircle } from "react-icons/ai";
import { FaArrowRight } from "react-icons/fa";

import "./CountrySelector.css";

const MultiSelectedListItem = ({
  value,
  onClick,
  onFocusClick,
  focusAvailable,
}) => {
  const [hover, setHover] = useState(false);

  const handleFocusClick = () => {
    onFocusClick(value);
  };

  const handleDeleteClick = () => {
    onClick(value);
  };

  const handleHoverOver = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };

  return (
    <div
      className="list-item--selected"
      onMouseOver={handleHoverOver}
      onMouseOut={handleMouseOut}
    >
      {hover ? (
        <AiFillMinusCircle
          className="delete-item-button"
          size={16}
          color="red"
          onClick={handleDeleteClick}
        />
      ) : null}
      <div className="list-item--selected__text">{value}</div>
      {focusAvailable ? (
        hover ? (
          <div className="focus-pill" onClick={handleFocusClick}>
            <div className="focus-text">explore</div>
            <FaArrowRight
              size={14}
              className="focus-country-button--focused"
              title="Focus on this country/region"
            />
          </div>
        ) : (
          <FaArrowRight
            size={14}
            className="focus-country-button"
            title="Focus on this country/region"
          />
        )
      ) : null}
    </div>
  );
};

export default MultiSelectedListItem;
